/** App-wide brand / display constants. */
export const APP_NAME = 'Vision Lab';
